module.exports = __webpack_public_path__ + "img/20240320155203031e3k.7613b9bc.jpg";